var OCS = OCS || {};
OCS.Viewer = OCS.Viewer || {};
OCS.Viewer.Classes = OCS.Viewer.Classes || {};
OCS.Viewer.Classes.AdvisoryFeature = new Class({
    Extends: OCS.Viewer.Classes.AbstractFeature,
    class_name: "AdvisoryFeature",
    geom_request: null,
    options: {
        properties: {
            dataset: 'edu.ou.ocs.advisories',
            ending_time: 0,
            issued_time: 0,
            phenom: '',
            significance: '',
            z_index: "0",
            zone_id: ""
        },
        event_display_time: 0,
        hightlight_timeout_delay: 500
    },
    style_ops: {},
    stored_styles: {},
    stored_geom: null,
    request_promise: null,
    hightlight_timeout: null,
    high_res_state: false,
    initialize: function (op) {
        this.parent(op);


    },

    compute_style_ops: function(highlighted, style_ops) {

        var style, ops;
        var f_color = this.get_advisory_color(this.options.properties.phenom, this.options.properties.significance);
        var f_z_index = 10000 - this.get_advisory_zindex(this.options.properties.phenom, this.options.properties.significance);

        ops = style_ops.advisory_style_ops;
        if (style_ops.layer_style_ops.hasOwnProperty('filled')) {
            ops.filled = style_ops.layer_style_ops.filled;
        }
        if (ops.filled && style_ops.layer_style_ops.hasOwnProperty('fill_opacity')) {
            ops.fill_opacity = parseFloat(style_ops.layer_style_ops.fill_opacity);
        }
        /* istanbul ignore if */
        var util = OCS.Viewer.Functions.get_utilities();
        if (ops.filled && util.is_undefined(ops.fill_opacity)) {
            // Use the alpha setting if we are filling without a fill opacity setting.
            ops.fill_opacity = parseFloat(style_ops.layer_style_ops.alpha);
        }


        if (style_ops.layer_style_ops.hasOwnProperty('highlight_opacity')) {
            ops.highlight_opacity = parseFloat(style_ops.layer_style_ops.highlight_opacity);
        }
        if (style_ops.layer_style_ops.hasOwnProperty('highlight_width_mult')) {
            ops.highlight_width_mult = parseFloat(style_ops.layer_style_ops.highlight_width_mult);
        }
        if (style_ops.layer_style_ops.hasOwnProperty('width')) {
            ops.width = parseFloat(style_ops.layer_style_ops.width);
        }

        var color = util.hexo2rgba(f_color, ops.fill_opacity);

        if (!highlighted) {
            style = new ol.style.Style({
                fill: new ol.style.Fill({
                    color: 'rgba(' + color.red + ',' + color.green + ',' + color.blue + ',' + ops.fill_opacity + ')',
                }),
                stroke: new ol.style.Stroke({
                    color: 'rgb(' + color.red + ',' + color.green + ',' + color.blue + ')',
                    width: parseFloat(ops.width)
                }),
                zIndex: f_z_index
            });
        } else {
            style = new ol.style.Style({
                stroke: new ol.style.Stroke({
                    color: 'rgb(' + color.red + ',' + color.green + ',' + color.blue + ')',
                    width: parseFloat(ops.width) * ops.highlight_width_mult
                }),
                fill: new ol.style.Fill({
                    color: 'rgba(' + color.red + ',' + color.green + ',' + color.blue + ',' + ops.highlight_opacity + ')'
                }),
                zIndex: f_z_index
            });
        }
        this.stored_styles[highlighted] = style;
    },

    /*
     * 
     * Event Listeners
     * 
     */
    layer_style_method: function (feature, res, style_ops) {
        if(this.request_promise) {
            this.request_promise.cancel();
            this.request_promise = null;
        }
        if(!this.stored_geom) {
            this.stored_geom = feature.getGeometry();
        }

        var geom_direct_result;
        var highlighted = feature.get('is_highlighted');
        var selected = feature.get('is_selected');
        if (selected) {
            highlighted = true;
        }
        if(!this.stored_styles[highlighted]) {
            this.compute_style_ops(highlighted, style_ops);
        }
        var style = this.stored_styles[highlighted];

        if(feature.get('active')) {
            if (this.options.properties.zone_id) {
                var simplification = OCS.Geometry.Functions.get_simplification(res);
                var geom = OCS.Geometry.Functions.getGeometryBySid(this.options.properties.zone_id, OCS.Viewer.Config.default_projection, simplification);
                if (geom) {
                    geom_direct_result = geom.get_geometry();
                    this.stored_geom = new ol.geom[geom_direct_result.type](geom_direct_result.coordinates);
                }
                else {
                    geom = OCS.Viewer.Functions.get_geometry_manager().request({
                        method: "geometries",
                        "id": this.options.properties.zone_id,
                        "projection": OCS.Viewer.Config.default_projection,
                        "simplify": simplification,
                        "max_ids_to_request": 1,
                        "time_to_request": -1
                    });
                    if (geom.then) {
                        // We got back a promise
                        geom.addEvent('complete', function (res) {
                            if (res && res.result && res.result.length && res.result[0]) {
                                var geom_result = res.result[0].get_geometry();
                                this.stored_geom = new ol.geom[geom_result.type](geom_result.coordinates);
                                style.setGeometry(this.stored_geom);
                                if (this.request_promise) {
                                    if(res <= 500) {
                                        this.high_res_state = true;
                                        feature.setGeometry(this.stored_geom);
                                    }
                                    // We had to store the promise, since it was not ready immediately, lets redraw this
                                    this.changed();
                                }
                            }

                            this.request_promise = null;
                        }.bind(this));
                        geom.start();
                        if (!geom.resolved) {
                            this.request_promise = geom;
                        }
                    }
                    if (geom.get_geometry) {
                        geom_direct_result = geom.get_geometry();
                        this.stored_geom = new ol.geom[geom_direct_result.type](geom_direct_result.coordinates);
                    }
                }
            }
            else {
                this.stored_geom = feature.getGeometry();
            }
        }
        style.setGeometry(this.stored_geom);
        if(res <= 500 && !this.high_res_state && !this.request_promise) {
            this.high_res_state = true;
            feature.setGeometry(this.stored_geom);
            this.changed();
        }
        if(res > 500 && this.high_res_state) {
            this.high_res_state = false;
            feature.setGeometry(this.geometry);
            this.changed();
        }

        return [style];

    },

    /*
     * Actions
     */
    create: function () {
        this.remove_all_events();
        if(this.geometry && Object.keys(this.geometry).length) {
            // Create the feature
            var feature = new ol.Feature({geometry: this.geometry});
            feature.setProperties(this.options.properties);
            feature.style_method = this.layer_style_method.bind(this);
            feature.set('active', false);
            this.set_ol_object(feature);
            this.changed();
        } else {
            return false;
        }
        return true;
    },
    // Retrieve the proper geometry to render
    // setup_feature: function(feature) {
    //
    //
    //     this.set_feature_from_geojson(geojson);
    // },
    set_adv_key: function (key) {
        var ol_obj = this.get_ol_object();
        if(ol_obj) {
            ol_obj.set('adv_key', key);
        }
    },

    reset_feature: function () {
        this.set_active(false);
        this.stored_geom = new ol.geom.Polygon([[]]);
        this.fireEvent('feature_reset', null, 1);
    },
    is_active: function(time) {
        if(time > this.options.properties.issued_time && time < this.options.properties.ending_time) {
            return true;
        } else {
            return false;
        }
    },
    get_advisory_config: function (product_phenom, product_sig) {
        return OCS.Advisories.Functions.get_adv_config(product_phenom, product_sig);
    },
    get_advisory_color: function (product_phenom, product_sig) {
        var obj = OCS.Advisories.Functions.get_adv_config(product_phenom, product_sig);
        if (!obj || !obj.color) {
            return "#00000044";
        }
        return obj.color;
    },
    get_advisory_name: function (product_phenom, product_sig) {
        var obj = OCS.Advisories.Functions.get_adv_config(product_phenom, product_sig);
        if (!obj || !obj.name) {
            return "MISSING from config file";
        }
        return obj.name;
    },
    get_advisory_type: function (product_phenom, product_sig) {
        var obj = OCS.Advisories.Functions.get_adv_config(product_phenom, product_sig);
        if (!obj || !obj.type) {
            return "MISSING from config file";
        }
        return obj.type;
    },
    get_advisory_zindex: function (product_phenom, product_sig) {
        var obj = OCS.Advisories.Functions.get_adv_config(product_phenom, product_sig);
        if (!obj || !obj.zindex) {
            return 0;
        }
        return obj.zindex;
    }

});
